export const generalInfo = {
	title: "INFORMATIONS GÉNÉRALES",
	fields: {
		image: {
			label: "Image du produit",
			ariaLabel: "Télécharger l'image du produit",
		},
		name: {
			label: "Nom",
			placeholder: "Nom du produit",
		},
		productType: {
			label: "Type de produit",
			placeholder: "Sélectionner le type",
			loading: "Chargement...",
		},
		sku: {
			label: "SKU",
			placeholder: "Saisissez le SKU",
			tooltip:
				"Le SKU (Stock Keeping Unit) est un code unique pour identifier le produit. Si vous ne le remplissez pas, nous en générerons un automatiquement.",
		},
		category: {
			label: "Catégorie",
			placeholder: "Sélectionner une catégorie",
		},
		menuCategory: {
			label: "Catégorie du menu",
			placeholder: "Sélectionner une catégorie de menu",
		},
		preparationTime: {
			label: "Temps de préparation",
			placeholder: "Saisissez le temps",
			tooltip:
				"Saisissez le temps nécessaire à la cuisine pour préparer ce produit en minutes",
			unit: "minutes",
		},
		description: {
			label: "Description",
			placeholder: "Rédigez une brève description",
		},
		hasAlcohol: {
			label: "Contient de l'alcool?",
			tooltip:
				"Lorsqu'il est activé, il apparaîtra sur le menu des clients qu'il contient de l'alcool",
			yes: "oui",
			no: "non",
		},
	},
	noCategory: "Sans catégorie",
};
